#import "./queued-email-fragment-sparse.graphql"

fragment EmailSequenceFragment on EmailSequence {
    id
    nextUnsentEmail {
        id
        deliveryTime
    }
    messageCount
    sentEmailsCount
    emailsQueued {
        ...QueuedEmailFragmentSparse
    }
    emailSequenceTemplate {
        id
        name
    }
}
